import isElectron from 'is-electron';
import styled from 'styled-components';
import { palette } from '../../theme/colors';

const SBackdrop = styled.div`
  background-color: ${palette.backDrop};
  cursor: default;
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: ${isElectron() ? 99 : 998};
  left: 0;
  top: 0;
`;

type BackdropProps = {
  setModal: React.Dispatch<React.SetStateAction<boolean>> | ((isOpen: boolean) => void);
  className?: string | undefined;
  onClick?: () => void;
};

export const Backdrop = ({ setModal, className, onClick }: BackdropProps) => {
  return (
    <SBackdrop
      className={className}
      onClick={() => {
        onClick?.();
        setModal(false);
      }}
    />
  );
};
